/*
 * November TO GO gift picker (snippets/togo-promo.liquid).
 * Every gift is a hidden 0 ₪ product in the cart with the `_gift` property.
 * - Add / remove from the card; the theme re-renders the card after each change.
 * - Trim: fewer paid products than gifts removes the extra gifts, last line first.
 * - Checkout nudge: gifts still to pick stop the first checkout press;
 *   "continue without" lets her through for this session.
 */
(() => {
  if (customElements.get('togo-pick')) return;

  const SKIP_KEY = 'o8-togo-skip';
  const skipped = (set) => {
    try {
      if (set) sessionStorage.setItem(SKIP_KEY, '1');
      return sessionStorage.getItem(SKIP_KEY) === '1';
    } catch (e) {
      return !!set;
    }
  };

  const miniCart = () => document.querySelector('mini-cart');
  const onCartPage = () => window.location.pathname.replace(/\/$/, '').endsWith('/cart');
  const sections = () => {
    const cart = miniCart();
    return cart && !onCartPage() ? cart.getSectionsToRender().map((section) => section.section) : [];
  };
  const post = (url, payload) =>
    fetch(url, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({ ...payload, sections: sections(), sections_url: window.location.pathname })
    }).then((r) => r.json());
  const render = (state) => {
    if (onCartPage()) return window.location.reload();
    const cart = miniCart();
    if (cart && state && state.sections) cart.renderContents(state);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
  };

  class TogoPick extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-trim')) {
        this.trim();
        return;
      }
      this.addEventListener('click', this.onClick.bind(this));
    }

    trim() {
      let over = -Number(this.dataset.allowed);
      const lines = [...this.querySelectorAll('[data-line]')].map((l) => {
        over += Number(l.dataset.qty);
        return { key: l.dataset.key, qty: Number(l.dataset.qty) };
      });
      const updates = {};
      for (const line of lines.reverse()) {
        if (over <= 0) break;
        const cut = Math.min(over, line.qty);
        updates[line.key] = line.qty - cut;
        over -= cut;
      }
      post(`${theme.routes.cart_update_url}.js`, { updates }).then(render).catch((e) => console.error(e));
    }

    async onClick(event) {
      if (event.target.closest('[data-nudge-go]')) return this.closeNudge();
      if (event.target.closest('[data-nudge-skip]')) return this.skip();
      const button = event.target.closest('button[data-add], button[data-key]');
      if (!button || button.disabled || this.classList.contains('is-busy')) return;
      this.classList.add('is-busy');
      try {
        const state = button.dataset.add
          ? await post(theme.routes.cart_add_url, {
              items: [{ id: Number(button.dataset.add), quantity: 1, properties: { _gift: 'november-2026' } }]
            })
          : await post(theme.routes.cart_change_url, { id: button.dataset.key, quantity: Number(button.dataset.qty) });
        if (state.status) throw new Error(state.description || 'cart update failed');
        render(state);
      } catch (e) {
        console.error(e);
        this.classList.remove('is-busy');
      }
    }

    nudge() {
      const box = this.querySelector('[data-nudge]');
      if (!box) return;
      box.hidden = false;
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    closeNudge() {
      const box = this.querySelector('[data-nudge]');
      if (box) box.hidden = true;
      const grid = this.querySelector('.togo-pick__grid');
      if (grid) grid.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    skip() {
      skipped(true);
      const checkout = document.querySelector('#mini-cart [name="checkout"]') || document.querySelector('[name="checkout"]');
      if (checkout) checkout.click();
    }
  }

  customElements.define('togo-pick', TogoPick);

  // Gifts still to pick → stop the first checkout press (capture phase, before the form submits).
  document.addEventListener(
    'click',
    (event) => {
      const checkout = event.target.closest('[name="checkout"]');
      // The terms checkbox gets first say; one message at a time.
      if (!checkout || event.defaultPrevented || skipped()) return;
      const card = [...document.querySelectorAll('togo-pick[data-picked]')].find(
        (el) => el.offsetParent !== null && Number(el.dataset.picked) < Number(el.dataset.allowed)
      );
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      card.nudge();
    },
    true
  );
})();
